import React from 'react';
import classNames from 'classnames';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { Typography } from '@mui/material';

const FooterSocial = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-social',
    className
  );

  return (
    <div
      {...props}
      className={classes}
    >
      <Typography>Contatos:</Typography>
      <ul className="list-reset">
        <li>
          <a href="https://api.whatsapp.com/send?phone=+5577999024465&text=Olá, vim através do seu site, gostaria de conhecer um pouco mais seus produtos." target="_blank">
            <WhatsAppIcon/>
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/agro.mind/" target="_blank">
            <InstagramIcon/>
          </a>
        </li>
        <li>
          <a href="https://www.google.com/maps/place/Agromind+Representa%C3%A7%C3%B5es+LTDA/@-12.0959425,-45.7986453,17z/data=!3m1!4b1!4m5!3m4!1s0x934a71d7d497d975:0x8dae7e9516b5b289!8m2!3d-12.0959362!4d-45.7963916" target="_blank">
            <AddLocationAltIcon/>
          </a>
        </li>
        <li>
          <a href="mailto:?subject=Agromind site&to=Agromind.adm@gmail.com&body=Olá, vim através do seu site, gostaria de conhecer um pouco mais seus produtos." target="_blank">
            <EmailIcon/>
          </a>
        </li>
      </ul>
    </div>
  )
}

export default FooterSocial